
function generateUniquePackUID() {
    const timestamp = Date.now();
    const randomComponent = Math.floor(Math.random() * 1000); // Random number between 0 and 999
    return `pack-${timestamp}-${randomComponent}`;
}

async function removeRelatedItemsWithoutParent() {
    let cart = await fetchCart();


    while (true) {
        const packUids = new Set(cart.items.filter(item => item.properties && item.properties['Pack UID'])
            .map(item => item.properties['Pack UID']));

        const itemsToRemove = cart.items.filter(item => item.properties && item.properties['Related to Pack UID'] &&
            !packUids.has(item.properties['Related to Pack UID']));

        if (itemsToRemove.length === 0) {
            break; // Exit the loop if there are no more items to remove
        }

        // Remove the first item in the list
        await removeItemFromCart(itemsToRemove[0].key);

        // Re-fetch the cart to get the updated state
        cart = await fetchCart();
    }
}

function fetchCart() {
    return fetch('/cart.js')
        .then(response => response.json());
}






function removeItemFromCart(lineItemKey) {
    return new Promise((resolve, reject) => {
        $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            dataType: 'json',
            data: {
                id: lineItemKey,
                quantity: 0,
            },
        })
            .done(function (updatedCart) {
                resolve(updatedCart);
            })
            .fail(function (error) {
                console.error('Error removing item:', error);
                reject(error);
            });
    });
}

function PackProductHandle() {
    fetch('/cart.js')
        .then((response) => response.json())
        .then((cart) => {
            removeRelatedItemsWithoutParent();
        })
        .catch((error) => {
            console.error('Error fetching cart:', error);
        });
}
PackProductHandle();

document.addEventListener('DOMContentLoaded', function () {
    const addToCartButton = document.getElementById('add-to-cart-pack');
    const packProductSelects = document.querySelectorAll('.pack-products-selection select');
    const mainProductVariantId = addToCartButton.getAttribute('variant-id');
    const priceDisplay = document.getElementById('product-pack-price');
    const priceButtonDisplay = document.getElementById('product-pack-price-button');

    // Function to calculate and update the subtotal
    function updateSubtotal() {
        let subtotal = 0;
        packProductSelects.forEach((select) => {
            const price = parseFloat(select.options[select.selectedIndex].getAttribute('data-price'));
            if (!isNaN(price)) {
                subtotal += price;
            }
        });

        // Assuming priceDisplay and priceButtonDisplay are already defined and reference the correct elements
        if (subtotal > 0) {
            // Update the text content and make elements visible
            priceDisplay.textContent = `Subtotal: €${subtotal.toFixed(2)}`;
            priceButtonDisplay.textContent = `€${subtotal.toFixed(2)}`;

            priceDisplay.style.display = ''; // Remove any inline display style
            priceButtonDisplay.style.display = ''; // Remove any inline display style
        } else {
            // Hide the elements if subtotal is 0
            priceDisplay.style.display = 'none';
            priceButtonDisplay.style.display = 'none';
        }
    }


    // Initialize the subtotal when the page loads
    updateSubtotal();

    // Add event listener to update subtotal when a product variant is selected
    packProductSelects.forEach((select) => {
        select.addEventListener('change', updateSubtotal);
    });

    if (addToCartButton) {
        addToCartButton.addEventListener('click', function (e) {
            e.preventDefault(); // Prevent the form from submitting normally.

            let selectedVariants = [];
            const properties = {};

            // Collect selected variants and prepare properties
            packProductSelects.forEach((select, index) => {
                const variantId = select.value;
                const productTitle = select.options[select.selectedIndex].getAttribute('choice-title');


                if (variantId && productTitle) {
                    properties[`Pack Product ${index + 1}`] = `${productTitle} (ID: ${variantId})`;
                    selectedVariants.push(variantId);
                } else {
                    console.error(`Missing product details for selection index ${index}: Variant ID or Product Title is missing.`);
                }
            });
            // Log each property of the properties object


            // Alternatively, log the entire properties object as a string
            if (Object.keys(properties).length === 0) {
                console.error('No pack product properties were collected. Aborting add to cart operation.');
                return;
            }

            // Prepare the FormData for the pack product
            const packFormData = new FormData();
            packFormData.append('id', mainProductVariantId);
            packFormData.append('quantity', 1);
            Object.keys(properties).forEach((key) => {
                packFormData.append(`properties[${key}]`, properties[key]);
            });

            // Call the function to add products to cart sequentially
            addProductsToCart(selectedVariants, packFormData);
        });
    } else {
        console.error('Add to Cart button not found.');
    }

    let packProductCounter = 0;

    async function addProductsToCart(variants, packFormData) {
        try {

            // // Log final properties before submit
            // for (var pair of packFormData.entries()) {
            //     console.log('Final Properties before submit:' + pair[0] + ', ' + pair[1]);
            // }
            // Generate a unique identifier for this pack product
            const packProductUID = generateUniquePackUID();
            packFormData.append('properties[Pack UID]', packProductUID);

            // Adding the pack product with properties
            const packResponse = await fetch('/cart/add.js', {
                method: 'POST',
                body: packFormData,
            });
            if (!packResponse.ok) {
                throw new Error(`HTTP error! status: ${packResponse.status}`);
            }
            await packResponse.json(); // Wait for the JSON response

            // Add each individual product to the cart sequentially
            for (const variantId of variants) {
                const variantFormData = new FormData();
                variantFormData.append('id', variantId);
                variantFormData.append('quantity', 1);
                variantFormData.append('properties[Related to Pack UID]', packProductUID);


                const variantResponse = await fetch('/cart/add.js', {
                    method: 'POST',
                    body: variantFormData,
                });
                if (!variantResponse.ok) {
                    throw new Error(`HTTP error! status: ${variantResponse.status}`);
                }
                await variantResponse.json(); // Wait for the JSON response
            }
            // Redirect to the cart page after adding all products
            window.location.href = '/cart';

        } catch (error) {
            console.error('Error adding products to cart:', error);
        }
    }


});
function calculatePackProductSubtotal(cartItems) {
    let packProductId = null;
    let subtotal = 0;

    // Find the Pack Product
    cartItems.forEach(item => {
        if (item.properties && item.properties["Pack Product"]) {
            packProductId = item.variant_id;
        }
    });

    // If Pack Product found, calculate subtotal of related items
    if (packProductId) {
        cartItems.forEach(item => {
            if (item.properties && item.properties["Related Product"] === packProductId.toString()) {
                subtotal += item.price;
            }
        });
    }
    return subtotal;
}


function PackProductHandle() {
    fetch('/cart.js')
        .then((response) => response.json())
        .then((cart) => {
            removeRelatedItemsWithoutParent();
            calculatePackProductSubtotal(cart.items); // Calculate and log the subtotal
        })
        .catch((error) => {
            console.error('Error fetching cart:', error);
        });
}

function packHandlingFrontBack() {
    setTimeout(PackProductHandle, 1500);
    setTimeout(removeRelatedItemsWithoutParent, 500);
    PackProductHandle()

};
